export default "__VITE_ASSET__A0Ou3nJB__"